@if (show) {
  <div [class]="customClass" [ngStyle]="{'top': positionTop, 'left': positionLeft}">
    <p class="dcp-body-small mb-2!">
      <strong>Must be at least 10 characters long and must include each of the following:</strong>
    </p>

    <ul class="list-disc list-outside ms-5">
      <li class="dcp-body-small">Uppercase Letter</li>
      <li class="dcp-body-small">Lowercase Letter</li>
      <li class="dcp-body-small">Number</li>
      <li class="dcp-body-small">Special Character From This Set: {{"~!@#$%^&*()-_=+[]{}|;:,.<>/?"}}</li>
      <li class="dcp-body-small">No Spaces</li>
      <li class="dcp-body-small">Not Have More Than 2 Repeating Chars</li>
      <li class="dcp-body-small">At Least 50% Different From The Last Password Used</li>
      <li class="dcp-body-small">Avoid Any Passwords Used In The Last 12 Months</li>
    </ul>
  </div>
}
